import React from 'react';
import ReactDOM from 'react-dom';
import 'firebase/firestore';
import App from './App';
import ReactGA from 'react-ga';

ReactGA.initialize('G-9JDG4E50ET');

ReactDOM.render(<App />, document.getElementById('root'));
